import React from "react";

const players = [
  { rank: 1, name: "Player", score: "23,500" },
  { rank: 2, name: "Player", score: "19,750" },
  { rank: 3, name: "Player", score: "16,300" },
  { rank: 4, name: "Player", score: "12,200" },
  { rank: 5, name: "Player", score: "9,000" },
  { rank: 6, name: "Player", score: "7,300" },
  { rank: 7, name: "Player", score: "6,700" },
  { rank: 8, name: "Player", score: "4,300" },
  { rank: 9, name: "Player", score: "3,100" },
  { rank: 10, name: "Player", score: "2,500" },
];

const Scoreboard = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-[#0a0f2c]">
      <div className="relative bg-[#142850] p-6 rounded-xl shadow-xl w-full max-w-md border-4 border-blue-500 text-center overflow-hidden flex flex-col items-center">
        {/* Background Grid Effect */}
        <div className="absolute inset-0 bg-[url('/grid-pattern.png')] opacity-20"></div>

        <h2 className="text-4xl font-extrabold text-blue-400 mb-6 tracking-wide neon-text">
          LEADERBOARD
        </h2>
        <div className="space-y-4 w-full relative z-10">
          {players.map((player) => (
            <div
              key={player.rank}
              className="flex justify-between items-center w-full p-4 rounded-lg border border-blue-400 text-blue-300 font-semibold bg-gradient-to-r from-blue-900 via-[#142850] to-blue-900 shadow-lg neon-border"
            >
              <span className="text-lg font-bold text-blue-500 neon-text">
                {player.rank}
              </span>
              <span className="text-lg">{player.name}</span>
              <span className="text-lg">{player.score}</span>
            </div>
          ))}
        </div>

        {/* Glowing Effects */}
        <style jsx>{`
          .neon-text {
            text-shadow:
              0 0 5px #00eaff,
              0 0 10px #00eaff,
              0 0 20px #00eaff;
          }
          .neon-border {
            box-shadow:
              0 0 10px #00eaff,
              0 0 20px #00eaff;
          }
        `}</style>
      </div>
    </div>
  );
};

export default Scoreboard;
